<mat-form-field subscriptSizing="dynamic" class="!w-40">
  <mat-label>Select Chart Type</mat-label>
  <mat-select [formControl]="typeCtrl">
    <mat-option *ngFor="let type of types; trackBy: trackByType" [value]="type">
      {{ type | titlecase }}
    </mat-option>
  </mat-select>
</mat-form-field>
